import actions from './actions';
import mutations from './mutations';

const state = {
    id: null,
    name: '',
    subdomain: '',
    displayName: '',
    logoUri: '',
    parentId: null,
    parent: null,
    children: null
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/client/store.js